import { StandardProps } from "@/types/types";
import {
  findFirstMatchingDimensionNameInFacets,
  getPrimaryFacetDisplayName,
  constants,
} from "@/utils/facet";
import { FilterDrawerButton } from "../FilterDrawerButton/FilterDrawerButton";

export function PrimaryFacet({
  productListingData,
  configProps,
}: Pick<StandardProps, "productListingData" | "configProps">) {
  const { facets } = productListingData;

  const dimensionNamesToSearchFor = [
    constants.AGE_RANGE_DIMENSION_NAME,
    constants.WOMENS_SIZE_DIMENSION_NAME,
    constants.MENS_SIZE_DIMENSION_NAME,
  ];

  const { matchingFacetName, matchingDimensionName } =
    findFirstMatchingDimensionNameInFacets(dimensionNamesToSearchFor, facets);

  const displayName = matchingFacetName
    ? getPrimaryFacetDisplayName({
        matchingFacetName,
        matchingDimensionName,
      })
    : undefined;

  if (!displayName) return null;

  return (
    <div data-component="PrimaryFacet">
      <FilterDrawerButton
        data-testid="primary-facet-button"
        productListingData={productListingData}
        configProps={configProps}
        name={displayName}
        targetFacetName={matchingFacetName}
      />
    </div>
  );
}
